<template>
    <div class="af" >
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                height="385"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
        >
            <el-table-column
                    align="center"
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_yw"
                    :label="$t('form_business')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width=""
                    :label="$t('form_operate')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.i_type==1" :disabled="scope.row.i_type==type?false:true" @click="godetail" type="text" size="small">{{$t('invoiceEntry_view_go_to_contact_logistics_to_terminate')}}</el-button>
                    <el-button v-if="scope.row.i_type==2" :disabled="scope.row.i_type==type?false:true" @click="godetail" type="text" size="small">{{$t('invoiceEntry_view_contact_logistics_to_cancel_close_without_transportation_business')}}</el-button>
                    <el-button v-if="scope.row.i_type==3" :disabled="scope.row.i_type==type?false:true" @click="godetail" type="text" size="small">{{$t('invoiceEntry_view_to_complete_approval')}}</el-button>
                    <el-button v-if="scope.row.i_type==4" :disabled="scope.row.i_type==type?false:true" @click="godetail" type="text" size="small">{{$t('invoiceEntry_click_release/click_view')}}</el-button>
                    <el-button v-if="scope.row.i_type==5" :disabled="scope.row.i_type==type?false:true" @click="godetail" type="text" size="small">{{$t('invoiceEntry_click_to_terminate/click_to_view')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary"  :class="baseerp+'btn'" size="small" @click="closeOr">{{$t('invoiceEntry_order_closed')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props: {
            orderdata: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                i_id:0,
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                mid: 0,
                showTable:true,
                loading:false,
                type:'',
                tableData: [
                    {i_type:1,vc_yw:this.$t('invoiceEntry_transportation_agreement')},
                    {i_type:2,vc_yw:this.$t('invoiceEntry_shipping_and_receiving_arrangements')},
                    {i_type:3,vc_yw:this.$t('invoiceEntry_abnormal_transportation')},
                    {i_type:4,vc_yw:this.$t('invoiceEntry_excessive_invoice_related_quantity')},
                    {i_type:5,vc_yw:this.$t('invoiceEntry_termination_of_warehouse_application')},
                ],
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("orderdata", this.orderdata);
            this.i_id=this.orderdata.row.i_id;
            this.closeState();
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
        },
        methods: {
            godetail(){
                this.closePreview()
            },
            // 查询关闭订单预览
            async closePreview(){
                let param = {
                    'i_id':this.i_id,
                    'i_type':this.type,
                };
                let res = await API.closePreview(param);
                if (res.code == 1) {
                    if(this.type==3){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>{{$t('invoiceEntry_exception_type')}}：${item.vc_type}</li>
                                    <li>异常品名：${item.vc_paname}</li>
                                    <li>异常数量：${item.f_lossnum}</li>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    <li>${item.i_ywstate==1?'已处理':'未处理'}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_complete_the_exception_approval'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if(this.type==1){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>运输单号：${item.vc_code}</li>
                                    <li>运输公司：${item.vc_yskhname}</li>
                                    <li>品名：${item.vc_pzname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量：${item.f_nosend}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_to_terminate_the_transportation_agreement'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if(this.type==2){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>状态：${item.stateTxt}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    <li>司机信息：${item.vc_tran_name+item.vc_tran_tel}</li>
                                    <li>品名：${item.vc_pzname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量：${item.f_noconfirm}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_for_cancellation_or_contact_the_warehouse_to_confirm_receipt'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if(this.type==5){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>入库申请ID：${item.i_id}</li>
                                    <li>品种：${item.vc_pzname}</li>
                                    <li>批次号：${item.vc_no}</li>
                                    <li>申请量：${item.f_num}</li>
                                    <li>入库量：${item.f_innum}</li>
                                    <li>短少量：${item.f_dsnum}</li>
                                    <li>途损量：${item.f_psnum}</li>
                                    <li>未执行量：${item.f_noconfirm}</li>
                                    <li>申请人：${item.vc_squname}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_after_closing_you_will_not_be_able_to_initiate_a_warehouse_application_are_you_sure_you_want_to_close_it'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            /*callback: action => {}*/
                        }).then(()=>{
                            this.closeSq(data)
                        });
                    }else if(this.type==4){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>品种：${item.vc_pzname}</li>
                                    <li>批次号：${item.vc_no}</li>
                                    <li>入库量：${item.f_rknum}</li>
                                    <li>关联量：${item.f_glnum}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_are_you_sure_you_want_to_release_the_excess_associated_quantity_and_transfer_it_in_transit'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            /*callback: action => {}*/
                        }).then(()=>{
                            this.closeToZt(data)
                        });
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //多出关联量转在途
            async closeToZt(list){
                let param = {
                    'i_id':this.i_id,
                    'ztList':list,
                };
                let res = await API.closeToZt(param);
                if (res.code == 1) {
                    this.closeState();
                    this.refreshTable();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            // 终止入库申请
            async closeSq(list){
                let param = {
                    'i_id':this.i_id,
                    'sqList':list,
                };
                let res = await API.closeSq(param);
                if (res.code == 1) {
                    this.closeState();
                    this.refreshTable();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            // 查询当前是否可关闭订单
            async closeState(){
                let param = {
                    'i_id':this.i_id,
                };
                let res = await API.closeState(param);
                if (res.code == 1) {
                    this.type = res.data.type;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            closeOr(){
                this.closeOrder()
            },
            //关闭订单
            async closeOrder(){
                this.loading=true;
                let param = {
                    i_id:this.i_id,
                };
                let res = await API.closeOrder(param);
                /*if(res.code == 0){
                    let i_type=res.data.i_type;
                    if(i_type==1){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>{{$t('invoiceEntry_exception_type')}}：${item.vc_type}</li>
                                    <li>异常品名：${item.vc_paname}</li>
                                    <li>异常数量：${item.f_lossnum}</li>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_complete_the_exception_approval'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if(i_type==2){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>运输单号：${item.vc_code}</li>
                                    <li>运输公司：${item.vc_yskhname}</li>
                                    <li>品名：${item.vc_paname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量：${item.f_nosend}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_to_terminate_the_transportation_agreement'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }else if( i_type==3){
                        let data=res.data.list;
                        this.$alert(`${data.map(item=>{
                            return `<ul>
                                    <li>收发货安排单号：${item.vc_code}</li>
                                    <li>车号：${item.vc_carno}</li>
                                    <li>司机信息：${item.vc_tran_name+item.vc_tran_tel}</li>
                                    <li>品名：${item.vc_paname}</li>
                                    <li>数量：${item.f_num}</li>
                                    <li>未执行量:${item.f_onconfirm}</li>
                                    </ul>`
                        })}`, this.$t('invoiceEntry_tip_please_contact_the_logistics_for_cancellation_or_contact_the_warehouse_to_confirm_receipt'), {
                            dangerouslyUseHTMLString: true,
                            type:'warning',
                            confirmButtonText: this.$t('button_sure'),
                            callback: action => {

                            }
                        });
                    }
                } else */
                if (res.code == 1) {
                    /*this.currentPage=1;
                    this.tableData=[];
                    this.tableTotal=0;
                    this.getOrders();*/
                    this.loading=false;
                    this.$emit('cancelDialog',1)
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },

            //订单列表
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_id':this.dataConnect.i_id,
                    /*'i_kpkhid':this.dataOrd.i_kpkhid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_fymx':this.dataOrd.vc_fymx,
                    'i_over':this.i_over,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'vc_search':this.vc_search,*/
                };
                if(this.i_fytype==1){
                    var res = await API.getGlFksq(param);
                }else{
                    var res = await API.getGlOrder(param);
                }
                if (res.code == 1) {
                    this.loading=false;
                    if(this.i_fytype==1){
                        res.data.list.map(item=>{
                            let file=item.vc_files.signfile;
                            item.vc_files.otherfiles.push(file);
                        })
                    }
                    this.tableData =  res.data.list;
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(()=>{
                        /*for(let i=0;i<this.tableData.length;i++){
                            let pz= this.tableData[i];
                            for(let s of this.dataOrd.selected){
                                if(pz.vc_no==s){
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)
                                }
                            }
                            for(let s of this.dataOrd.disselect){
                                if(pz.vc_no==s){
                                    //pz.disabled=true;
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)

                                }
                            }
                        }*/
                        if(res.data.total==1){
                            this.expend=true;
                            this.refreshTable()
                        }
                    });

                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            async saveForm(){
                //console.log('this.multipleSelection',this.multipleSelection)
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_an_order'));
                }else{
                    if(this.dataOrd.i_flag==1&&this.multipleSelection.length>1){
                        this.$message.error(this.$t('invoiceEntry_only_one_order_can_be_selected_from_the_import_tax_bill_and_import_invoice'));
                        return;
                    }
                    let arr = this.multipleSelection.filter(item => {
                        return item.i_over == 0
                    });
                    let arrlen = arr.length;
                    //console.log(arrlen,'arrlen');
                    if(arrlen>1){
                        this.$message.error(this.$t('invoiceEntry_only_one_order_can_be_selected_during_execution_if_multiple_selections_are_required_please_close_any_orders_that_will_not_be_executed_in_the_future'));
                        return;
                    }else{
                        //判断是否只有禁用的
                        let alldis = this.multipleSelection.every(item=>{
                            return item.disabled==true
                        })
                        //console.log('alldis',alldis)
                        //if(alldis){
                        //    this.cancel()
                        //}else{
                            let orderWs='';
                            let arr = [];
                            let ids = [];
                            this.multipleSelection.map(item=>{
                                arr.push(item.vc_no)
                                ids.push(item.vc_no)
                            });
                            //console.log(arr,'arr')
                            orderWs=arr.toString();
                            //console.log(orderWs,'orderws')
                            let map={
                                orderWs:orderWs,
                                ids:ids,
                                details:this.dataOrd.i_flag==1?this.multipleSelection[0].details:null,
                                i_bzid_yb:this.multipleSelection[0].i_bzid_yb,
                                multipleSelection:this.multipleSelection,
                            }
                            this.$emit('cancelDialog_order',map)
                        //}
                    }
                }
            },
            cancel(){
                this.$emit('cancelDialog');
            },

        }
    }
</script>
<style>
   .el-message-box{
        width: 550px !important;
    }
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    /deep/ .el-table th{
            //text-align: left !important;
        }

    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .grey{
        color: grey;
    }
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex_e{
        display: flex;
        justify-content: end;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
